import React from 'react';
import './index.css'

const Text = ({text, ownClass, color, size}) => {
    let newClass = ownClass ? ownClass : ''
    let textSize = size ? size : ''
    return (
        <span className={`main-text ${newClass} ${textSize}`} style={{color: color}}>
            {text}
        </span>
    )
}

export default Text;